import {
  getV1DealerIdBorrowerBorIdDemographics,
  putV1DealerIdBorrowerBorIdDemographics,
  type DtoUpdateDemographicsReq,
} from "@porchpass/api-client";
import { assertApiSuccess } from "../utils/assertApiSuccess";
import { lazyDealerId, requireBorrowerId, type DomainIds } from "./types";

export function createDemographicsDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getDemographics: async (borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdDemographics(
        getDealerId(),
        borId,
      );
      return assertApiSuccess(response);
    },

    updateDemographics: async (
      body: DtoUpdateDemographicsReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorIdDemographics(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },
  };
}
